module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-header.7b972c73.png";